import Axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { api_url } from "../../../config";
import { authActions } from "../../../context/actions/authActions";
import useStore from "../../../context/useStore";
import Bouton from "../../common/HorsConnexion/Bouton";
import EcranResultat from "../../common/HorsConnexion/EcranResultat";
import FormulaireMotDePasse from "../../common/HorsConnexion/FormulaireMotDePasse";
import {
  MESSAGE_SERVEUR_INDISPONIBLE,
  extraireErreurMotDePasse,
  messageErreur,
} from "../../common/HorsConnexion/horsConnexion";
import "../../common/HorsConnexion/hors-connexion.scss";

/**
 * Renouvellement annuel du mot de passe, imposé à la connexion
 * (`mustRenewPassword`) : carte de la charte dans l'espace connecté (l'en-tête
 * reste là, avec « Se déconnecter »). Mêmes appels qu'avant : PATCH
 * recipients/me/password, puis reconnexion et notification de succès.
 */
const RenewPasswordLoggedIn = () => {
  const [state, dispatch] = useStore();
  const actions = authActions(state, dispatch);
  const [enregistrement, setEnregistrement] = useState(false);
  const [erreurMdp, setErreurMdp] = useState(null);
  const [erreurGenerale, setErreurGenerale] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  function enregistrer(password) {
    setEnregistrement(true);
    setErreurGenerale(null);
    Axios.patch(api_url + "recipients/me/password", { password })
      .then(() => {
        actions.loginUser({ login: state.auth.user.email, password });
        toast.success("Votre mot de passe a bien été modifié.");
        setIsSuccess(true);
      })
      .catch((err) => {
        const donnees = err.response && err.response.data;
        const messageMdp = extraireErreurMotDePasse(donnees);
        if (messageMdp) setErreurMdp(messageMdp);
        else setErreurGenerale(messageErreur(donnees) || MESSAGE_SERVEUR_INDISPONIBLE);
      })
      .then(() => setEnregistrement(false));
  }

  return (
    <div className="hc hc--carte">
      {isSuccess ? (
        <EcranResultat ton="succes" icone="coche" titre="Mot de passe modifié">
          <p>Votre nouveau mot de passe est actif.</p>
          <Bouton to="/">Accéder à mon espace</Bouton>
        </EcranResultat>
      ) : (
        <section aria-labelledby="titre-renouvellement">
          <h1 id="titre-renouvellement">Renouvelez votre mot de passe</h1>
          <p className="sous-titre">
            Pour garantir la sécurité de vos informations, votre mot de passe se change tous les ans.{" "}
            <strong>Vous ne pouvez pas réutiliser un ancien mot de passe.</strong>
          </p>
          <FormulaireMotDePasse
            onEnregistrer={enregistrer}
            enregistrement={enregistrement}
            erreurMdp={erreurMdp}
            onEffacerErreurMdp={() => setErreurMdp(null)}
            erreurGenerale={erreurGenerale}
            libelle="Modifier mon mot de passe"
          />
        </section>
      )}
    </div>
  );
};

export default RenewPasswordLoggedIn;
